import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BcmApiService } from '@modules/bcm/@shared/services';
import { IUnit } from '@shared/models/unit';
import { PayableOption } from '@shared/models/payable-option';
import { ElectricMeterProductType } from '@shared/models/electric-meter-product-type';

@Injectable({
    providedIn: 'root'
})
export class ElectricMeterProductTypeApiService extends BcmApiService {

    private RESOURCE_ENDPOINT = 'products/electric-meter-product-types';

    getAll(params: HttpParams = new HttpParams()): Observable<ElectricMeterProductType[]> {
        return super.get<ElectricMeterProductType[]>(this.RESOURCE_ENDPOINT, params);
    }

}
